import { render, staticRenderFns } from "./TemplateDraft.vue?vue&type=template&id=5c2271c1&scoped=true&"
import script from "./TemplateDraft.vue?vue&type=script&lang=js&"
export * from "./TemplateDraft.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDraft.vue?vue&type=style&index=0&id=5c2271c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2271c1",
  null
  
)

export default component.exports